module.exports = __webpack_public_path__ + "media/icons/arrow-down-6fcacd3462e0ab14810b71858a15d2d8.svg";